import { css, StyleSheet } from 'aphrodite/no-important'
import PropTypes from 'prop-types'
import { Icon } from '@lmc/ui-kit'
import colors from '@lmc/common/constants'

export const BlankState = ({
  className,
  children,
  heading,
  component: Component,
  ...props
}) => {
  return (
    <Component {...props} className={css(classes.container, className)}>
      <Icon name="SearchOutlined" style={styles.search} />
      {!!heading && <h2 className={css(classes.heading)}>{heading}</h2>}
      {children}
    </Component>
  )
}

const styles = {
  search: {
    fontSize: 50,
  },
}

BlankState.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  heading: PropTypes.string,
}

BlankState.defaultProps = {
  component: 'div',
}

const classes = StyleSheet.create({
  container: {
    backgroundColor: colors.white,
    borderRadius: 20,
    color: colors.grey,
    paddingBottom: '4em',
    paddingLeft: '2em',
    paddingRight: '2em',
    paddingTop: '4em',
    textAlign: 'center',
  },
  heading: {
    color: 'inherit',
    ':last-child': {
      marginBottom: 0,
    },
  },
})

export default BlankState
